import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries';

const styles = (theme) => ({
  root: {
    borderRadius: theme.radius.full,
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightFacetBold,
  },
  buttonLoader: {
    color: theme.palette.common.white,
  },
  primaryBlueButtonLoader: {
    color: theme.palette.facet.primaryBlue,
  },
});

const RoundedButton = ({
  className,
  classes,
  children,
  isLoading,
  variant,
  test,
  useBlueButtonLoader,
  ...rest
}) => {
  return (
    <Button
      className={classNames(classes.root, className)}
      disableElevation
      padding={'thick'}
      variant={variant}
      test={test}
      startIcon={isLoading && (
        <CircularProgress
          className={classNames(classes.buttonLoader, {
            [classes.primaryBlueButtonLoader]: variant === 'outlined' && useBlueButtonLoader,
          })}
          size={20}
        />)
      }
      {...rest}
    >
      {children}
    </Button>
  );
};

RoundedButton.defaultProps = {
  className: '',
  isLoading: false,
  disableElevation: true,
  color: 'primary',
  variant: 'contained',
  useBlueButtonLoader: true,
  test: '',
};

RoundedButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  disableElevation: PropTypes.bool,
  color: PropTypes.string,
  variant: PropTypes.string,
  useBlueButtonLoader: PropTypes.bool,
  test: PropTypes.string,
};

export default withStyles(styles)(RoundedButton);
